import { render } from "./validation.vue?vue&type=template&id=0ee30ee3"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__